import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import moment from 'moment';

import { Button } from '..';

import { Stopover as StopoverType } from '../../types';

type StopoverOmissionDataProps = {
  selectedStopover: StopoverType;
  // Quando informado, exibe a ação de remover a omissão no próprio alerta.
  onRemoveOmission?: () => void;
  isLoadingRemoveOmission?: boolean;
};

export function StopoverOmissionData(props: StopoverOmissionDataProps) {
  const { selectedStopover, onRemoveOmission, isLoadingRemoveOmission } = props;
  const { omission_date, omission_motivation, omission_updated_by } =
    selectedStopover;

  const omittedBy =
    typeof omission_updated_by === 'string'
      ? omission_updated_by
      : omission_updated_by?.name;

  return (
    <div>
      <Alert
        message={
          <>
            <span>
              Escala omitida
              {omission_date
                ? ` em: ${moment(omission_date).format('DD/MM/YYYY HH:mm')}`
                : ''}
              {omittedBy ? ` por: ${omittedBy}` : ''}
            </span>
            <br />
            <span>Motivo: {omission_motivation}</span>
          </>
        }
        type="warning"
        showIcon
        style={{ margin: '20px' }}
        icon={<InfoCircleOutlined />}
        action={
          onRemoveOmission ? (
            <Button
              size="small"
              danger
              loading={isLoadingRemoveOmission}
              onClick={() => onRemoveOmission()}
            >
              Remover omissão
            </Button>
          ) : null
        }
      />
    </div>
  );
}
